<div class="rewardsContainer">
    <!-- Desktop Table -->
    <div class="tableContainer" [ngClass]="userInfo.loyaltyLevel?.toLowerCase()">
        <table class="rewards-table">
            <tr class="categoryUser">
                <td class="title-column"></td>
                <td class="pro-column">
                    <ng-container *ngIf="userInfo?.loyaltyLevel?.toLowerCase() === 'advanced'">
                        {{ 'benefits_we.esta_es_tu_categoria' | translate }}
                    </ng-container>
                </td>
                <td class="elite-column">
                    <ng-container *ngIf="userInfo?.loyaltyLevel?.toLowerCase() === 'elite'">
                        {{ 'benefits_we.esta_es_tu_categoria' | translate }}
                    </ng-container>
                </td>
                <td class="premium-column">
                    <ng-container *ngIf="userInfo?.loyaltyLevel?.toLowerCase() === 'premium'">
                        {{ 'benefits_we.esta_es_tu_categoria' | translate }}
                    </ng-container>
                </td>
            </tr>
            <tr class="table-head">
                <td class="title-column"></td>
                <td class="pro-column">{{ 'benefits_we.pro' | translate }}</td>
                <td class="elite-column">{{ 'benefits_we.elite_p' | translate }}</td>
                <td class="premium-column">{{ 'benefits_we.premium_p' | translate }}</td>
            </tr>
            <tr *ngFor="let row of tableRows">
                <ng-container *ngFor="let cell of row.rows">
                    <td [ngClass]="cell.classTd">
                    <span [ngClass]="cell.classSpan">{{ cell.label }}</span>
                    </td>
                </ng-container>
            </tr>
        </table>
    </div>
    <!-- Mobile View -->
    <div class="mobileContainer" *ngIf="userMobileRow">
        <div [ngClass]="userMobileRow.classContainer">
            <div class="benefits-wrapper">
                <div *ngFor="let item of userMobileRow.rows" [ngClass]="item.classMobile">
                    <ng-container *ngIf="item.userCategory; else normalItem">
                        <p class="user-category">{{ item.label }}</p>
                    </ng-container>
                    <ng-template #normalItem>
                        <div>
                            <span [ngClass]="item.classSpan">{{ item.labelMobile }}</span>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>
